import { render, staticRenderFns } from "./candidate-preference-modal.vue?vue&type=template&id=ad76cfe4&"
import script from "./candidate-preference-modal.vue?vue&type=script&lang=js&"
export * from "./candidate-preference-modal.vue?vue&type=script&lang=js&"
import style0 from "@/styles/candidate/candidate-preference.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
